import React from 'react';
import { AdminLayout } from 'apps/sigma2-ui/src/components/AdminLayout';
import { Paragraph } from 'apps/sigma2-ui/src/components/ui/Paragraph';
import { useDatabasesPage } from 'apps/sigma2-ui/src/data-wizard/lib/useDatabasesPage';
import { SelectBoxWithSearch } from 'apps/sigma2-ui/src/components/ui/SelectBoxWithSearch';
import { Button } from 'apps/sigma2-ui/src/components/ui/Button';
import { noBehavior } from 'apps/sigma2-ui/src/components/ui/TouchTarget';

export const DatabasesPage = () => {
  const {
    selectedOrganization,
    setSelectedOrganization,
    organizations,
    organizationSelectBoxLabel,
    welcomeText,
  } = useDatabasesPage();

  return (
    <>
      <AdminLayout currentPage={'Databases'}>
        <Paragraph>{welcomeText}</Paragraph>
        <SelectBoxWithSearch
          type="single"
          list={organizations}
          label={organizationSelectBoxLabel}
          selected={selectedOrganization ?? ''}
          setSelected={setSelectedOrganization}
        />
        <Button
          behavior={
            selectedOrganization === null
              ? noBehavior
              : {
                  type: 'href',
                  href: `/organizations/${selectedOrganization}/databases`,
                }
          }
          text={'Next'}
          disabled={selectedOrganization === null}
        />
      </AdminLayout>
    </>
  );
};
